import _ from "lodash";
import {
  ELEMENT_TYPE_CONCEPT,
  ELEMENT_TYPE_LEARNER_PROFILE,
  ELEMENT_TYPE_DP_LEARNER_PROFILE,
  ELEMENT_TYPE_PYP_BENCHMARK,
  ELEMENT_TYPE_ATL,
  ELEMENT_TYPE_UBD_LEARNING_STANDARD,
  ELEMENT_TYPE_MYP_LEARNING_STANDARD,
  ELEMENT_TYPE_DP_SUBJECT_STANDARD,
  ELEMENT_TYPE_MYP_ATL,
  ELEMENT_TYPE_UBD_ATL,
  ELEMENT_TYPE_DP_ATL,
  ELEMENT_TYPE_UBD_SUBJECT,
  ELEMENT_TYPE_MYP_SUBJECT,
  ELEMENT_TYPE_DP_SUBJECT,
} from "Constants/stringConstants";

const config = {
  [ELEMENT_TYPE_CONCEPT]: {
    levelType: "single",
  },
  [ELEMENT_TYPE_LEARNER_PROFILE]: {
    levelType: "single",
  },
  [ELEMENT_TYPE_DP_LEARNER_PROFILE]: {
    levelType: "single",
  },
  [ELEMENT_TYPE_PYP_BENCHMARK]: {
    isNestedData: true,
    levelType: "multi",
  },
  [ELEMENT_TYPE_ATL]: {
    isNestedData: true,
    levelType: "multi",
  },
  [ELEMENT_TYPE_UBD_LEARNING_STANDARD]: {
    isNestedData: true,
    levelType: "multi",
    isSubjectDependent: true,
    subjectType: ELEMENT_TYPE_UBD_SUBJECT,
  },
  [ELEMENT_TYPE_MYP_LEARNING_STANDARD]: {
    isNestedData: true,
    levelType: "multi",
    isSubjectDependent: true,
    subjectType: ELEMENT_TYPE_MYP_SUBJECT,
  },
  [ELEMENT_TYPE_DP_SUBJECT_STANDARD]: {
    isNestedData: true,
    levelType: "multi",
    isSubjectDependent: true,
    subjectType: ELEMENT_TYPE_DP_SUBJECT,
  },
  [ELEMENT_TYPE_MYP_ATL]: {
    isNestedData: true,
    levelType: "single",
  },
  [ELEMENT_TYPE_UBD_ATL]: {
    isNestedData: true,
    levelType: "single",
  },
  [ELEMENT_TYPE_DP_ATL]: {
    isNestedData: true,
    levelType: "single",
  },
};

export const getElementTypeConfig = ({ type }) => {
  return _.get(config, [type], {});
};

export const addSubjectNode = ({ elementList, subjectType }) => {
  if (!_.isEmpty(elementList)) {
    let updatedElementList = [...elementList];
    let subjectArray = [];
    //To Support different Subjects and Learning Standards in interdisciplinary Learning
    _.forEach(updatedElementList, element => {
      const associatedParents = _.get(element, "associatedParents", []);
      const associatedSubjectParent = _.find(
        associatedParents,
        parent => parent["__typename"] == "Subject"
      );
      const isAlreadyAddedSubject = _.find(
        subjectArray,
        subject => subject.id == associatedSubjectParent.id
      );
      if (!isAlreadyAddedSubject) {
        subjectArray = [...subjectArray, associatedSubjectParent];
      }
    });
    updatedElementList = _.map(subjectArray, subject => {
      const childrenElement = _.filter(elementList, element => {
        const elementSubjectAssociatedParent = _.find(
          _.get(element, "associatedParents", []),
          parent => parent["__typename"] == "Subject"
        );
        return (
          _.get(elementSubjectAssociatedParent, "id", "") ==
          _.get(subject, "id", "")
        );
      });
      return {
        id: subject.id,
        label: subject.name,
        children: childrenElement,
        levelId: 0,
        type: subjectType,
        ibPlannerElementType: subjectType,
      };
    });
    return updatedElementList;
  }
  return elementList;
};

export const createStandardLabelsMap = assessmentField => {
  if (!assessmentField) {
    return {};
  }

  // Try to get labels from resolvedMinimalTree.nodes first
  const minimalTreeNodes = _.get(
    assessmentField,
    "resolvedMinimalTree.nodes",
    []
  );

  // Create initial map from resolvedMinimalTree.nodes
  const labelsMapFromNodes = _.reduce(
    minimalTreeNodes,
    (result, node) => {
      if (node && node.id) {
        result[node.id] = node.label || `Standard ${node.id}`;
      }
      return result;
    },
    {}
  );

  // Fallback to options if needed, but prioritize the values from resolvedMinimalTree
  const standardLabelsMap = _.reduce(
    _.get(assessmentField, "options", []),
    (result, option) => {
      // Only add from options if not already present from resolvedMinimalTree
      if (option.value && !result[option.value]) {
        result[option.value] = option.label;
      }
      return result;
    },
    labelsMapFromNodes
  );

  return standardLabelsMap;
};
